/* src/app/modules/shared/components/header-column/header-column-strain/header-column-strain.component.scss */
app-header-column-strain {
  display: contents;
}
/*# sourceMappingURL=header-column-strain.component.css.map */
